import { MsdsComponent } from "../components/msdsComponent"

export const MsdsPage = () => {
  document.title = "MSDS"
  return (<MsdsComponent page="msds" />)
}